module.exports = __webpack_public_path__ + "img/900528482.d8248efb.png";